var map = {
	"./ai/blog.json": 5115,
	"./android/blog.json": 8946,
	"./arvr/blog.json": 1321,
	"./biotech/blog.json": 6192,
	"./blockchain/blog.json": 8359,
	"./devops/blog.json": 1507,
	"./frontend/blog.json": 2409,
	"./ios/blog.json": 5481,
	"./pm/blog.json": 9307,
	"./qa/blog.json": 176,
	"./quantum-computing/blog.json": 1948,
	"./web/blog.json": 6510
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6474;
module.exports = webpackAsyncContext;